export class ListIngestionPipelineDeadLettersResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "nextToken",
            "baseName": "nextToken",
            "type": "string",
            "format": ""
        },
        {
            "name": "totalCount",
            "baseName": "totalCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "deadLetters",
            "baseName": "deadLetters",
            "type": "Array<IngestionPipelineDeadLetter>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListIngestionPipelineDeadLettersResponse.attributeTypeMap;
    }
    constructor() {
    }
}
